import { render } from "./delete-property-modal.vue?vue&type=template&id=476e51a8&scoped=true&lang=pug"
import script from "./delete-property-modal.vue?vue&type=script&lang=js"
export * from "./delete-property-modal.vue?vue&type=script&lang=js"

import "./delete-property-modal.vue?vue&type=style&index=0&id=476e51a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476e51a8"]])

export default __exports__